import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import * as actions from '../actions'
import { selectors as productSelectors } from '../../products/reducer'
import * as apiActions from 'api-actions'
import {
  Path,
  isAROAddonsEnabled,
  isNotificationsAddonEnabled,
} from 'config/portal'
import { SelectCompanyInformationForm } from '../forms'
import SharedSelectCompanyInformationView from '../../products/views/SelectCompanyInformationView'

function SelectCompanyInformationView(props) {
  const getNextPathname = () => {
    if (!isAROAddonsEnabled()) {
      return '/automatic-rollovers/complete-services-agreement'
    }
    return isNotificationsAddonEnabled()
      ? '/automatic-rollovers/add-additional-products'
      : Path.ADD_NEW_BD_ADDENDUM_IN_ARO
  }

  return (
    <SharedSelectCompanyInformationView
      {...props}
      redirectPath={Path.ADD_NEW_SERVICES_AGREEMENT}
      nextPathname={getNextPathname()}
      SelectCompanyInformationFormComponent={SelectCompanyInformationForm}
    />
  )
}

function mapStateToProps(state) {
  return {
    completeServicesAgreementForm:
      selectors.completeServicesAgreementForm(state),
    servicesAgreements: productSelectors.servicesAgreements(state),
    erisapediaSearches: selectors.erisapediaSearches(state),
  }
}

const mapDispatchToProps = {
  fetchServicesAgreements: apiActions.fetchServicesAgreements,
  fetchErisapediaSearches: apiActions.fetchErisapediaSearches,
  setCompleteServicesAgreementForm: actions.setCompleteServicesAgreementForm,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SelectCompanyInformationView
)
